const constants = Object.freeze({
	floatToFixed: 5
})

export default constants